/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const REQUEST_DRUG_PRICE_LOAD_LOADING =
  'REQUEST_DRUG_PRICE_LOAD_LOADING';
export const REQUEST_DRUG_PRICE_LOAD_PRICE_TYPE_DATA =
  'REQUEST_DRUG_PRICE_LOAD_PRICE_TYPE_DATA';
export const REQUEST_DRUG_PRICE_LOAD_REBATE_PROGRAM_DATA =
  'REQUEST_DRUG_PRICE_LOAD_REBATE_PROGRAM_DATA';
export const UPLOAD_SAVE_DISABLE = 'UPLOAD_SAVE_DISABLE';
export const REQUEST_DRUG_PRICE_LOAD_DEFAULT_QUATER =
  'REQUEST_DRUG_PRICE_LOAD_DEFAULT_QUATER';
export const REQUEST_DRUG_PRICE_LOAD_USER_DEFAULT =
  'REQUEST_DRUG_PRICE_LOAD_USER_DEFAULT';
export const REQUEST_DRUG_PRICE_LOAD_SEARCH_FILTER =
  'REQUEST_DRUG_PRICE_LOAD_SEARCH_FILTER';
export const REQUEST_DRUG_PRICE_LOAD_DETAILS_FILTER =
  'REQUEST_DRUG_PRICE_LOAD_DETAILS_FILTER';
export const CUSTOM_ADDDATA_URA = 'CUSTOM_ADDDATA_URA';
export const REQUEST_DRUG_PRICE_LOAD_DETAILS_REFERENCE_DATA =
  'REQUEST_DRUG_PRICE_LOAD_DETAILS_REFERENCE_DATA';
export const REQUEST_DRUG_PRICE_LOAD_DETAILS_CHANGED =
  'REQUEST_DRUG_PRICE_LOAD_DETAILS_CHANGED';
export const REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA =
  'REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA';
export const REQUEST_DRUG_PRICE_LOAD_DETAILS_COMPARE_TABLEDATA =
  'REQUEST_DRUG_PRICE_LOAD_DETAILS_COMPARE_TABLEDATA';
export const REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA_LOADED =
  'REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA_LOADED';
export const REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_DATA =
  'REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_DATA';
export const RESET_REQUEST_DRUG_PRICE_LOAD_STORE =
  'RESET_REQUEST_DRUG_PRICE_LOAD_STORE';
export const TRIGER_COMMENTS_EXIST_CHECK = 'TRIGER_COMMENTS_EXIST_CHECK';
export const CURRENT_CORR_LINK_ID = 'CURRENT_CORR_LINK_ID'